import { render, staticRenderFns } from "./postTiktok.vue?vue&type=template&id=f2d46b3a"
import script from "./postTiktok.vue?vue&type=script&lang=js"
export * from "./postTiktok.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2d46b3a')) {
      api.createRecord('f2d46b3a', component.options)
    } else {
      api.reload('f2d46b3a', component.options)
    }
    module.hot.accept("./postTiktok.vue?vue&type=template&id=f2d46b3a", function () {
      api.rerender('f2d46b3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/renderPost/postTiktok.vue"
export default component.exports